import type {
  OrganizationDetail,
  OrganizationMinimal,
} from "@/entities/organization";

export const getLocationCreateParentOrganization = (
  organization?: OrganizationDetail | undefined
): OrganizationMinimal | undefined => {
  if (!organization) return undefined;

  return {
    id: organization.id,
    name: organization.name,
  };
};
